/**
 * Dutch names for countries (ISO 3166-1 alpha-2 code -> Dutch name).
 * Used when app language is Dutch. Fallback to API name if code not in map.
 */
export const countryNamesNl: Record<string, string> = {
  AD: 'Andorra',
  AE: 'Verenigde Arabische Emiraten',
  AF: 'Afghanistan',
  AG: 'Antigua en Barbuda',
  AI: 'Anguilla',
  AL: 'Albanië',
  AM: 'Armenië',
  AO: 'Angola',
  AR: 'Argentinië',
  AT: 'Oostenrijk',
  AU: 'Australië',
  AW: 'Aruba',
  AZ: 'Azerbeidzjan',
  BA: 'Bosnië en Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'België',
  BF: 'Burkina Faso',
  BG: 'Bulgarije',
  BH: 'Bahrein',
  BI: 'Burundi',
  BJ: 'Benin',
  BN: 'Brunei',
  BO: 'Bolivia',
  BR: 'Brazilië',
  BS: 'Bahama\'s',
  BT: 'Bhutan',
  BW: 'Botswana',
  BY: 'Wit-Rusland',
  BZ: 'Belize',
  CA: 'Canada',
  CD: 'Congo-Kinshasa',
  CF: 'Centraal-Afrikaanse Republiek',
  CG: 'Congo-Brazzaville',
  CH: 'Zwitserland',
  CI: 'Ivoorkust',
  CL: 'Chili',
  CM: 'Kameroen',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Kaapverdië',
  CY: 'Cyprus',
  CZ: 'Tsjechië',
  DE: 'Duitsland',
  DJ: 'Djibouti',
  DK: 'Denemarken',
  DM: 'Dominica',
  DO: 'Dominicaanse Republiek',
  DZ: 'Algerije',
  EC: 'Ecuador',
  EE: 'Estland',
  EG: 'Egypte',
  ER: 'Eritrea',
  ES: 'Spanje',
  ET: 'Ethiopië',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falklandeilanden',
  FM: 'Micronesia',
  FO: 'Faeröer',
  FR: 'Frankrijk',
  GA: 'Gabon',
  GB: 'Verenigd Koninkrijk',
  GD: 'Grenada',
  GE: 'Georgië',
  GF: 'Frans-Guyana',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Groenland',
  GM: 'Gambia',
  GN: 'Guinee',
  GQ: 'Equatoriaal-Guinea',
  GR: 'Griekenland',
  GT: 'Guatemala',
  GW: 'Guinee-Bissau',
  GY: 'Guyana',
  HK: 'Hongkong',
  HN: 'Honduras',
  HR: 'Kroatië',
  HT: 'Haïti',
  HU: 'Hongarije',
  ID: 'Indonesië',
  IE: 'Ierland',
  IL: 'Israël',
  IN: 'India',
  IQ: 'Irak',
  IR: 'Iran',
  IS: 'IJsland',
  IT: 'Italië',
  JM: 'Jamaica',
  JO: 'Jordanië',
  JP: 'Japan',
  KE: 'Kenia',
  KG: 'Kirgizië',
  KH: 'Cambodja',
  KI: 'Kiribati',
  KM: 'Comoren',
  KN: 'Saint Kitts en Nevis',
  KP: 'Noord-Korea',
  KR: 'Zuid-Korea',
  KW: 'Koeweit',
  KY: 'Kaaimaneilanden',
  KZ: 'Kazachstan',
  LA: 'Laos',
  LB: 'Libanon',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Litouwen',
  LU: 'Luxemburg',
  LV: 'Letland',
  LY: 'Libië',
  MA: 'Marokko',
  MC: 'Monaco',
  MD: 'Moldavië',
  ME: 'Montenegro',
  MG: 'Madagaskar',
  MK: 'Noord-Macedonië',
  ML: 'Mali',
  MM: 'Myanmar',
  MN: 'Mongolië',
  MO: 'Macau',
  MR: 'Mauritanië',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldiven',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Maleisië',
  MZ: 'Mozambique',
  NA: 'Namibië',
  NE: 'Niger',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Nederland',
  NO: 'Noorwegen',
  NP: 'Nepal',
  NR: 'Nauru',
  NZ: 'Nieuw-Zeeland',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'Frans-Polynesië',
  PG: 'Papoea-Nieuw-Guinea',
  PH: 'Filipijnen',
  PK: 'Pakistan',
  PL: 'Polen',
  PT: 'Portugal',
  PY: 'Paraguay',
  QA: 'Qatar',
  RO: 'Roemenië',
  RS: 'Servië',
  RU: 'Rusland',
  RW: 'Rwanda',
  SA: 'Saoedi-Arabië',
  SB: 'Salomonseilanden',
  SC: 'Seychellen',
  SD: 'Soedan',
  SE: 'Zweden',
  SG: 'Singapore',
  SI: 'Slovenië',
  SK: 'Slowakije',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalië',
  SR: 'Suriname',
  SS: 'Zuid-Soedan',
  ST: 'Sao Tomé en Principe',
  SV: 'El Salvador',
  SY: 'Syrië',
  SZ: 'Eswatini',
  TD: 'Tsjaad',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tadzjikistan',
  TL: 'Oost-Timor',
  TM: 'Turkmenistan',
  TN: 'Tunesië',
  TO: 'Tonga',
  TR: 'Turkije',
  TT: 'Trinidad en Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Oekraïne',
  UG: 'Oeganda',
  US: 'Verenigde Staten',
  UY: 'Uruguay',
  UZ: 'Oezbekistan',
  VA: 'Vaticaanstad',
  VC: 'Saint Vincent en de Grenadines',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Jemen',
  ZA: 'Zuid-Afrika',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
};

export type CountryLike = { code: string; name: string };

export function getCountryDisplayName(country: CountryLike | null | undefined, locale: string): string {
  if (!country) return '';
  if (locale === 'nl' && countryNamesNl[country.code]) {
    return countryNamesNl[country.code];
  }
  if (locale && locale !== 'en' && country.code && !country.code.includes('-')) {
    try {
      const names = new Intl.DisplayNames([locale], { type: 'region' });
      const label = names.of(country.code);
      if (label) return label;
    } catch {
      /* ignore */
    }
  }
  return country.name;
}
